// src/context/TrackGalleryContext.jsx
import React, { createContext, useState } from "react";

export const TrackGalleryContext = createContext({
  filteredTracks: null,
  setFilteredTracks: () => {},
});

export function TrackGalleryProvider({ children }) {
  const [filteredTracks, setFilteredTracks] = useState([]);

  return (
    <TrackGalleryContext.Provider value={{ filteredTracks, setFilteredTracks }}>
      {children}
    </TrackGalleryContext.Provider>
  );
}
